// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Tooltip, Typography } from '@mui/material';
import { useCopyToClipboard } from './useCopyToClipboard';

const PartyDisplay = ({ party }: { party: string }) => {
  const copy = useCopyToClipboard();
  const onClick = () => {
    copy(party);
  };
  return (
    <Tooltip title={`click to copy: ${party}`}>
      <Typography
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        sx={{
          maxWidth: '200px',
          cursor: 'pointer',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        variant="body2"
      >
        {party}
      </Typography>
    </Tooltip>
  );
};

export default PartyDisplay;
